module.exports = __webpack_public_path__ + "img/logo_cdjvul_1920x1080.cf0fec67.png";